import __var_0__ from './symbols.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* SVG symbols.
*
* @module @stdlib/plot/components/svg/symbols
*
* @example
* var Symbols = require( '@stdlib/plot/components/svg/symbols' );
*
* var symbols = new Symbols({
*     'x': [0.1,0.2,0.3],
*     'y': [0.4,0.5,0.6]
* });
*/

// MODULES //
var Symbols = __var_0__;


// EXPORTS //
export default Symbols;
